<ng-container *ngFor="let service of services">
  <a
    *ngIf="currentUser.isSubscribed()"
    [href]="service.url"
    class="{{ service.type }}"
    type="button"
    mat-icon-button
    target="_blank"
  >
    <mat-icon [svgIcon]="iconColor+'-'+service.icon" [matTooltip]="service.title | trans"></mat-icon>
  </a>
  <a
    *ngIf="!currentUser.isSubscribed()"
    [href]="service.url"
    type="button"
    mat-icon-button
    target="_blank"
  >
    <mat-icon [svgIcon]="iconColor+'-'+service.icon" [matTooltip]="service.title | trans"></mat-icon>
  </a>
</ng-container>
